export const projectsRecord = [
  {
    projectName: "Healthcare Management Platform",
    imgSrc: "/assets/healthcare.png",
    url: "",
    description:
      "Built secure backend services for a HIPAA-compliant healthcare platform using FHIR standards, supporting patient records, caregiver workflows, scheduling, and healthcare interoperability. Project details are confidential.",
  },
  {
    projectName: "Finlily Technology",
    imgSrc: "/assets/finlilly.png",
    url: "https://www.finlilytechnology.in/",
    description:
      "Full-stack fintech platform including web, mobile, and admin applications for secure financial operations and business management.",
  },
  {
    projectName: "Fahm-e-Quran",
    imgSrc: "/assets/Fahm-e-quran.PNG",
    url: "https://fahm-e-quran.vercel.app/",
    description:
      "Online learning platform featuring class scheduling, student progress tracking, and course management.",
  },
  {
    projectName: "My Beauty Hub",
    imgSrc: "/assets/beautyhub.png",
    url: "https://www.mybeautyhub.de/",
    description:
      "Beauty and wellness platform with appointment scheduling, service management, and an administrative dashboard.",
  },
  {
    projectName: "Geeked Out Basketball",
    imgSrc: "/assets/geekedout.png",
    url: "https://www.geekedoutbasketball.com/",
    description:
      "Sports gaming platform where I led backend development and contributed to the Next.js frontend and gameplay features.",
  },
  {
    projectName: "AI-Powered RAG System",
    imgSrc: "/assets/rag.PNG",
    url: "https://rag-system-client-seven.vercel.app/",
    description:
      "Built an AI-powered Retrieval-Augmented Generation (RAG) system that combines document ingestion, semantic search, vector embeddings, and LLM-based generation to provide context-aware answers from private knowledge sources.",
  },
  {
    projectName: "PropQwiz",
    imgSrc: "/assets/propqwiz.png",
    url: "https://play.google.com/store/apps/details?id=com.graymattersdigital.propqwiz&pli=1",
    description:
      "Cross-platform React Native application delivering an interactive real estate quiz experience.",
  },
];